<template>
    <div class="maskbg">
        <div class="dialog vr">
            <div class="close" @click="handleClose"></div>
            <div class="main">
                <iframe 
                    :src="src" 
                    width="100%" 
                    height="100%" 
                    frameborder="0" 
                    allowfullscreen>
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        src: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
        }
    },
    created() {
    },
    methods: {
        handleClose(){
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common';
@import '@/styles/dialog';
</style>